<template>
    <x-page title="Add PDF">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>

        <translation-upload-batch-form
            id="translation-upload-batch-form"
            :enable-name-check="true"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
        />

        <template #footer>
            <x-submit-button
                form="translation-upload-batch-form"
                :is-loading="isLoading"
                :disabled="isLoading"
            />
        </template>
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XSubmitButton from "../../components/XSubmitButton.vue";
import { handleValidationXhrError } from "../../helpers";
import TranslationUploadBatchForm from "./TranslationUploadBatchForm.vue";

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        TranslationUploadBatchForm,
    },
    data() {
        return {
            errors: null,
            isLoading: false,
        };
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true;
            const request = axios
                .post(`/api/translation-upload-batches`, fields, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.$notify({
                        type: "success",
                        title: `Berhasil`,
                        text: `${response.data.data.display_name} added!`,
                    });
                    this.$router.back();
                });
            return handleValidationXhrError(request, (errors) => {
                this.errors = errors;
            }).finally(() => {
                this.isLoading = false;
            });
        },
    },
};
</script>
